import React from 'react'
import { ReactComponent as TriggerIcon } from "assets/svg/createTrigger.svg"
import styles from './TriggerButton.module.scss'

const TriggerButton = ({ handleClick }) => {
  return (
    <div className={styles?.buttonContainer}>
      <label
        onClick={handleClick}
        // htmlFor={name} 
        className={styles?.buttonLabel}>
        <TriggerIcon width={16} height={16} />
        <span>Create Trigger</span>
      </label>
    </div>
  )
}

export default TriggerButton